import React, { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const { processGoogleSession } = useAuth();
  const navigate = useNavigate();
  const returnPath = `${window.location.pathname}${window.location.search}` || '/dashboard';

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace('#', ''));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }

    (async () => {
      try {
        const user = await processGoogleSession(sessionId);
        navigate(returnPath, { replace: true, state: { user } });
      } catch (err) {
        console.error('Google auth failed:', err);
        navigate('/login', { replace: true });
      }
    })();
  }, [processGoogleSession, navigate, returnPath]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F3EF]">
      <div className="flex flex-col items-center gap-4">
        <div className="w-10 h-10 border-2 border-[#0B1F3F] border-t-transparent rounded-full animate-spin" />
        <p className="text-sm text-[#64748B] font-medium tracking-wide uppercase">Authenticating...</p>
      </div>
    </div>
  );
}
